import React from "react";
import {
  Chip,
  Menu,
  MenuItem,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import {
  CheckCircleOutline as CheckCircleOutlineIcon,
  HourglassEmpty as HourglassEmptyIcon,
  Autorenew as AutorenewIcon,
  ForwardToInbox as ForwardToInboxIcon,
  Cancel as CancelIcon,
  HighlightOff as HighlightOffIcon,
} from "@mui/icons-material";

/* ================= Status helpers ================= */

export const STATUS_OPTIONS = [
  {
    value: 0,
    label: "Pendente",
    colorKey: "pending",
    icon: <HourglassEmptyIcon fontSize="small" />,
  },
  {
    value: 1,
    label: "Em Atendimento",
    colorKey: "inProgress",
    icon: <AutorenewIcon fontSize="small" />,
  },
  {
    value: 2,
    label: "Concluída",
    colorKey: "success",
    icon: <CheckCircleOutlineIcon fontSize="small" />,
  },
  {
    value: 3,
    label: "Contato Futuro",
    colorKey: "future",
    icon: <ForwardToInboxIcon fontSize="small" />,
  },
  {
    value: 4,
    label: "Perdida",
    colorKey: "unsuccessful",
    icon: <HighlightOffIcon fontSize="small" />,
  },
  {
    value: 5,
    label: "Cancelada",
    colorKey: "canceled",
    icon: <CancelIcon fontSize="small" />,
  },
];

export function normalizeStatusInput(v) {
  if (v === null || v === undefined || v === "" || v === "0") return 0;
  const n = Number(v);
  return Number.isFinite(n) && n >= 0 && n <= 5 ? n : 0;
}

const StatusChipSelector = ({ currentStatus, onStatusChange, size = "small" }) => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const normalized = normalizeStatusInput(currentStatus);
  const current =
    STATUS_OPTIONS.find((s) => s.value === normalized) || STATUS_OPTIONS[0];

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  const handleSelect = (value) => {
    const n = normalizeStatusInput(value);
    onStatusChange && onStatusChange(n);
    handleClose();
  };

  // mesma lógica de cores do getStatusChip
  const isLightLabel =
    current.label === "Pendente" ||
    current.label === "Em Atendimento" ||
    current.label === "Contato Futuro";

  const bgColor = theme.palette.status[current.colorKey];
  const textColor = isLightLabel
    ? theme.palette.text.primary
    : theme.palette.common.white;

  return (
    <>
      <Tooltip title={current.label}>
        <Chip
          label={current.label}
          size={size}
          onClick={handleOpen}
          sx={{
            backgroundColor: bgColor,
            color: textColor,
            fontSize: "0.75rem",
            height: size === "small" ? "24px" : "28px",
            cursor: "pointer",
          }}
        />
      </Tooltip>

      <Menu
        id="status-selector-menu-header"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        MenuListProps={{ "aria-labelledby": "status-chip-selector" }}
      >
        {STATUS_OPTIONS.map((option) => (
          <MenuItem
            key={`status-${option.value}`}
            selected={normalized === option.value}
            onClick={() => handleSelect(option.value)}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              fontSize: "0.9rem",
              color: theme.palette.text.primary,
              "&.Mui-selected, &.MuiMenuItem-root.Mui-selected": {
                backgroundColor: theme.palette.status[option.colorKey],
                color: theme.palette.common.white,
              },
              "&.MuiMenuItem-root:hover": {
                backgroundColor: theme.palette.status[option.colorKey],
                color: theme.palette.common.white,
              },
            }}
          >
            {option.icon}
            <Typography variant="body2">{option.label}</Typography>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default StatusChipSelector;

